
























import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import type { PropType } from '@vue/composition-api';

import { defineComponent, ref, onMounted, watch } from '@vue/composition-api';
import type { ChatParticipant, Conversation, LastReadBy, Message, Typing } from '../types';
import ChatMessage from './ChatMessage.vue';
import ChatTypingStatus from './ChatTypingStatus.vue';

export default defineComponent({
  name: 'ChatContent',
  components: {
    ChatMessage,
    ChatTypingStatus,
  },
  props: {
    user: {
      type: Object as PropType<User>,
      default: undefined,
    },
    recipients: {
      type: Array as PropType<Array<Recipient>>,
      default: () => [],
    },
    conversation: {
      type: Object as PropType<Conversation>,
      default: undefined,
    },
    owner: {
      type: Object as PropType<ChatParticipant>,
      default: undefined,
    },
    lastReads: {
      type: Array as PropType<Array<LastReadBy>>,
      default: () => [],
    },
    typing: {
      type: Array as PropType<Array<Typing>>,
      default: () => [],
    },
  },
  emits: ['read', 'reply', 'delete'],
  setup(props, { emit }) {
    const chatContent = ref(null);

    const scrollToBottom = (smooth = false): void => {
      if (!chatContent.value) {
        return;
      }
      chatContent.value.scrollTo({
        top: chatContent.value.scrollHeight,
        behavior: smooth ? 'smooth' : 'auto',
      });
    };

    watch(
      () => props.conversation.messages,
      () => {
        scrollToBottom(true);
      }
    );

    const handleRead = (messageId: string) => {
      emit('read', messageId);
    };

    const handleDelete = (messageId: string) => {
      emit('delete', messageId);
    };

    const handleReply = (message: Message) => {
      emit('reply', message);
    };

    onMounted(() => {
      scrollToBottom();
    });

    return { chatContent, scrollToBottom, handleRead, handleReply, handleDelete };
  },
});
